export default "__VITE_ASSET__DSPTRLE$__"